const isPendingUserBubbleEvent = (event = {}) => {
  if (event?.type !== 'bubble') {
    return false;
  }

  if (
    String(event?.className || '')
      .trim()
      .toLowerCase() !== 'user'
  ) {
    return false;
  }

  return String(event?.id || '')
    .trim()
    .startsWith('pending-user-');
};

export default isPendingUserBubbleEvent;
